import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AddIcon from '@mui/icons-material/AddOutlined';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SearchIcon from '@mui/icons-material/Search';
import DeleteConfirmation from '../MultiDeleteConfirmation';
import { Button, Row, Col, UncontrolledTooltip } from 'reactstrap';
import Search from './Search';
import { defaultColumnCompartor } from '../../utils';
import { DataGrid } from '@mui/x-data-grid';

const List = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(true);
    const [showSearch, setShowSearch] = useState(false);

    const handleDelete = () => {
        props.onDelete(deleteConfirmationState.toDelete.map(x => x.courseId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }
    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleSelect = (selectedItem) => {
        if (props.fromTraining === true) {
            const id = selectedItem.id
            props.getCourse(id);
            props.history.push(`/courses/course/${id}`, { id })
        }
        else 
            props.onSelect && props.onSelect(selectedItem.id);
    }

    const handleToggleSearch = () => {
        props.clearSearchedCourses();
        setShowSearch(!showSearch);
    };

    const handleSelectionChanged = (e) => {
        if(props.hideButtons === true)
            props.onSelectionChanged(props.courses.filter(x => e.find(y => y === x.courseId))) 
        else if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.courses.filter(x => e.find(y => y === x.courseId)),
            });
            setDeleteEnabled(false);
        }
        else
            setDeleteEnabled(true);
    }

    const handleAddFromSearch = (selectedCourses, addSections) => {
        handleToggleSearch();
        props.onAddFromSearch(selectedCourses, addSections);
    };

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const getColumnDefinitions = () => {
        var columns = [{
            headerName: 'Description',
            field: 'description',
            flex: 3,
            comparator: defaultColumnCompartor
        }];

        if (!props.hideNameField) {
            columns.unshift({
                headerName: 'Name',
                field: 'name',
                flex: 3,
                comparator: defaultColumnCompartor
            });
        }

        return columns;
    }

    var toolTip;
    switch (props.title) {
        case 'Courses':
            toolTip = 'Course';
            break;
        case 'Sessions':
            toolTip = 'Session';
            break;
        case 'Learner Outcomes':
            toolTip = 'Learner Outcome';
            break;
        //This is stupid but it fixes the console warning
        default:
            toolTip = 'Session';
    }

    return (
        <React.Fragment>
            {!props.hideButtons && (
                <Row className='mb-1'>
                    <Col>
                        <h3>{props.title}</h3>
                    </Col>
                    <Col className='d-flex flex-row-reverse'>
                        <Button
                            id='deleteButton'
                            onClick={handleDeleteClick}
                            disabled={deleteEnabled}
                        >
                            <DeleteIcon />
                        </Button>
                        <UncontrolledTooltip
                            delay={{ show: 0, hide: 0 }}
                            target='deleteButton'
                        >
                            Delete {props.toolTip || toolTip}.
                        </UncontrolledTooltip>

                        {!props.hideAddButton && (
                            <React.Fragment>
                                <Button id='addButton' onClick={props.onAdd} className='me-1'>
                                    <AddIcon />
                                </Button>
                                <UncontrolledTooltip
                                    delay={{ show: 0, hide: 0 }}
                                    target='addButton'
                                >
                                    Add a new {toolTip}.
                                </UncontrolledTooltip>
                            </React.Fragment>
                        )}

                        {!props.hideSearchButton && (
                            <React.Fragment>
                                <Button
                                    id='searchButton'
                                    onClick={handleToggleSearch}
                                    className='me-1'
                                >
                                    <SearchIcon />
                                </Button>
                                <UncontrolledTooltip
                                    delay={{ show: 0, hide: 0 }}
                                    target='searchButton'
                                >
                                    Search for {props.toolTip || toolTip}.
                                </UncontrolledTooltip>
                            </React.Fragment>
                        )}
                    </Col>
                </Row>
            )}
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid
                            rows={props.courses?.map(x => { return { id: x.courseId, ...x } }) || []}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 25 } },
                            }}
                            columns={getColumnDefinitions()}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'}
                        />
                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                title={`Delete ${props.title}`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => x.name)}
                isOpen={deleteConfirmationState.display}
            />
            <Search
                isOpen={showSearch}
                toggle={handleToggleSearch}
                onSearch={props.onSearch}
                data={props.searchResults}
                onAdd={handleAddFromSearch}
                title={props.searchTitle || 'Search Courses'}
                showOptions={props.showOptions || false}
            />
        </React.Fragment>
    );
};

List.propTypes = {
    courses: PropTypes.array,
    onDelete: PropTypes.func,
    onSelect: PropTypes.func,
    onNew: PropTypes.func,
};

export default List;